export default __webpack_public_path__ + "static/media/andre-benz.87564532.jpg";